import Vue from 'vue'
import Vuex from 'vuex'
import getHomeData from './modules/home'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    getHomeData
  }
})
